import { ToastError, ToastSuccess } from "components/Global/Toasts/Toasty";
import { takeLatest } from "redux-saga/effects";
import { defaultReturn, generateDefaultActions, makePayload, makeWritePayload, requestSaga } from "shared-utility/store/utils/helpers";

// ACTIONS

export const SET_REPORT_COMPONENT_SELECTIONS = generateDefaultActions("SET_REPORT_COMPONENT_SELECTIONS");
export const setReportComponentSelections = payload => makeWritePayload(SET_REPORT_COMPONENT_SELECTIONS.value, payload);

export const PUT_REPORT_COMPONENT = generateDefaultActions("PUT_REPORT_COMPONENT");
const putReportComponentConfig = payload => makePayload(PUT_REPORT_COMPONENT.value, payload);
function* putReportComponentConfigSaga({ data }) {
  const url = "/report-components";
  yield requestSaga(PUT_REPORT_COMPONENT, url, "PUT", data, null, null, true);
}

export const POST_REPORT_COMPONENT = generateDefaultActions("POST_REPORT_COMPONENT");
const postReportComponentConfig = payload => makePayload(POST_REPORT_COMPONENT.value, payload);
function* postReportComponentConfigSaga({ data }) {
  const url = "/report-components";
  yield requestSaga(POST_REPORT_COMPONENT, url, "POST", data, null, null, true);
}

export const PUT_PROJECTED_REPORT_COMPONENT = generateDefaultActions("PUT_PROJECTED_REPORT_COMPONENT");
const putProjectedReportComponentConfig = payload => makePayload(PUT_PROJECTED_REPORT_COMPONENT.value, payload);
function* putProjectedReportComponentConfigSaga({ data }) {
  const url = "/report-components/projected";
  yield requestSaga(PUT_PROJECTED_REPORT_COMPONENT, url, "PUT", data, null, null, true);
}

export const POST_PROJECTED_REPORT_COMPONENT = generateDefaultActions("POST_PROJECTED_REPORT_COMPONENT");
const postProjectedReportComponentConfig = payload => makePayload(POST_PROJECTED_REPORT_COMPONENT.value, payload);
function* postProjectedReportComponentConfigSaga({ data }) {
  const url = "/report-components/projected";
  yield requestSaga(POST_PROJECTED_REPORT_COMPONENT, url, "POST", data, null, null, true);
}

export const actionCreators = {
  putReportComponentConfig,
  postReportComponentConfig,
  putProjectedReportComponentConfig,
  postProjectedReportComponentConfig,
  setReportComponentSelections
};

// REDUCER
const initialState = {
  selectedReportComponent: null,
  isSaving: false,
  isSavingComplete: false,
  wasNewReportComponentSaved: false,
  savedReportComponent: null
};

export function lenderReportingReportComponentReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_REPORT_COMPONENT_SELECTIONS.value:
      return defaultReturn({ ...state, ...payload });

    case PUT_REPORT_COMPONENT.value:
      return defaultReturn({ ...state, isSaving: true });
    case PUT_REPORT_COMPONENT.failure:
      ToastError("Failed to update existing report component");

      return defaultReturn({ ...state, isSaving: false, isSavingComplete: true });
    case PUT_REPORT_COMPONENT.success:
      ToastSuccess("Report component was successfully updated");

      return defaultReturn({ ...state, isSaving: false, isSavingComplete: true });

    case POST_REPORT_COMPONENT.value:
      return defaultReturn(state, true, "isSaving");
    case POST_REPORT_COMPONENT.failure:
      ToastError("Failed to create new report component.");

      return defaultReturn({ ...state, isSaving: false, isSavingComplete: true });
    case POST_REPORT_COMPONENT.success:
      ToastSuccess("New report component was successfully created.");
      return defaultReturn({ ...state, isSaving: false, isSavingComplete: true, wasNewReportComponentSaved: true, savedReportComponent: payload.data });

    case PUT_PROJECTED_REPORT_COMPONENT.value:
      return defaultReturn(state, true, "isSaving");
    case PUT_PROJECTED_REPORT_COMPONENT.failure:
      ToastError("Failed to update existing projected report component");
      return defaultReturn({ ...state, isSaving: false, isSavingComplete: true });
    case PUT_PROJECTED_REPORT_COMPONENT.success:
      ToastSuccess("Projected report component was successfuly updated");
      return defaultReturn({...state, isSaving: false, isSavingComplete: true });

      case POST_PROJECTED_REPORT_COMPONENT.value:
        return defaultReturn(state, true, "isSaving");
      case POST_PROJECTED_REPORT_COMPONENT.failure:
        ToastError("Failed to create a projected report component");
        return defaultReturn({ ...state, isSaving: false, isSavingComplete: true });
      case POST_PROJECTED_REPORT_COMPONENT.success:
        ToastSuccess("New projected report component was successfuly created");
        return defaultReturn({...state, isSaving: false, isSavingComplete: true, wasNewReportComponentSaved: true, savedReportComponent: payload.data });

    default:
      return state;
  }
}

// SAGA
export function* lenderReportingReportComponentSaga() {
  yield takeLatest(PUT_REPORT_COMPONENT.value, putReportComponentConfigSaga);
  yield takeLatest(POST_REPORT_COMPONENT.value, postReportComponentConfigSaga);
  yield takeLatest(PUT_PROJECTED_REPORT_COMPONENT.value, putProjectedReportComponentConfigSaga);
  yield takeLatest(POST_PROJECTED_REPORT_COMPONENT.value, postProjectedReportComponentConfigSaga);
}
